import "./ShortFilm.module.css";
import Navigation from "@/reusable_sections/Header";
import GameplayShowcase from "./sections/GameplayShowcase";
import WorkflowTimeline from "./sections/WorkflowTimeline";
import EngineeringExcellence from "./sections/EngineeringExcellence";
import Footer from "@/reusable_sections/Footer";
export default function ShortFilmPage() {
  return <div>
      <Navigation />
      <GameplayShowcase />
      <WorkflowTimeline />
      <EngineeringExcellence />
      <Footer />
    </div>;
}